import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '96',
  label: 'Practices ready to run'
}, {
  value: '3',
  label: 'Kids per ball'
}, {
  value: '0',
  label: 'Kids waiting in line'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy-mid" data-id="element-292" data-mp="29scplvtpnggw">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-12" data-id="element-293" data-mp="25tn93uddlit1">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-294" data-mp="32j4les6v633p">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-295" data-mp="2xkjj8n81x9cm">
              <div className="font-display text-4xl font-bold leading-none text-gold sm:text-5xl" data-id="element-296" data-mp="2thdi1tzsq8d0">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-white/65" data-id="element-297" data-mp="2oloc98x6nv89">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}